<div class="page-container">
  <div class="card-container">
    <div class="header">{{ headerData }}</div>
    <div class="content" *ngIf="formGroup && date">
      <div class="params">

        <div class="date-select">
          <!-- Choix par date -->
          <div class="radio-date">
            <div class="radio-wrapper">
              <input type="radio" name="repeat-type" [formControl]="formGroup.get('repeatType')" value="dates">
              <div class="radio-label">
                <span class="label-wording">Sélection de dates</span>
              </div>
            </div>
            <div class="calendar" [ngClass]="{ 'inactive': formGroup.get('repeatType').value !== 'dates' }">
              <div class="small-calendar-navigation">
                <div class="chevron-button previous" (click)="navigateToPrevious()">
                </div>
                <div class="current-date">{{ date | date:"MMMM yyyy" }}</div>
                <div class="chevron-button next" (click)="navigateToNext()"></div>
              </div>

              <!-- Template du header du calendrier affichant les jours de la semaine -->
              <!-- Il est vide pour que les jours ne soient pas affichés -->
              <ng-template #headerTemplate></ng-template>

              <mwl-calendar-month-view [headerTemplate]="headerTemplate" locale="fr" [viewDate]="date"
                (dayClicked)="dayClicked($event)" [weekStartsOn]="1"></mwl-calendar-month-view>
            </div>
          </div>

          <div class="separator"></div>

          <!-- Choix par récurrence -->
          <div class="radio-reccur">
            <div class="radio-wrapper">
              <input type="radio" name="repeat-type" [formControl]="formGroup.get('repeatType')" value="reccur">
              <div class="radio-label">
                <span class="label-wording">Répétition automatique</span>
              </div>
            </div>
            <div class="reccur-form" [ngClass]="{ 'inactive': formGroup.get('repeatType').value !== 'reccur' }">
              <!-- <frg-form-input
              id="reccurUnity"
              [selectValue]="reccurUnityList"
              type="ngSelect"
              [formGroup]="formGroup"
              [control]="formGroup.get('reccurUnity')"
              [isClearableSelect]="false"
            ></frg-form-input> -->

              <div class="label">Répéter tou(te)s les</div>
              <div class="offset-values-wrapper">
                <input class="offset-input" *ngIf="formGroup" [formControl]="formGroup.get('reccurOffset')"
                  type="number">
                <frg-form-input id="reccurUnity" [selectValue]="reccurUnityList" type="text" [formGroup]="formGroup"
                  [control]="formGroup.get('reccurUnity')"></frg-form-input>
              </div>

              <!-- Affichage si l'unité de récurrence est en semaines -->
              <div class="days-wrapper" *ngIf="type === 'day' && formGroup.get('reccurUnity').value === 'semaines'">
                <div class="day-label title">Le</div>
                <div class="day-values">
                  <div *ngFor="let day of daysInWeek"
                    (click)="formGroup.get('dayOfWeek').value.includes(day.value) ? removeDay(day) : addDay(day)"
                    class="day-label-container"
                    [ngClass]="{ 'selected': formGroup.get('dayOfWeek').value.includes(day.value) }">
                    <span class="day-label">{{ day.label }}</span>
                  </div>
                </div>
              </div>

              <div class="reccur-repeat-radio">
                <div class="radio-wrapper">
                  <input type="radio" name="reccur-type" [formControl]="formGroup.get('reccurType')" value="iteration">
                  <div class="radio-label">
                    <span class="label-wording">Répéter </span>
                  </div>
                </div>

                <input class="reccur-repeat-iteration"
                  [ngClass]="{ 'inactive': formGroup.get('reccurType').value !== 'iteration' }" type="number"
                  [formGroup]="formGroup" [formControl]="formGroup.get('reccurTypeIteration')" min="1">
                fois
              </div>

              <div class="reccur-repeat-radio">
                <div class="radio-wrapper">
                  <input type="radio" name="reccur-type" [formControl]="formGroup.get('reccurType')" value="to-date">
                  <div class="radio-label">
                    <span class="label-wording">Jusqu'au </span>
                  </div>
                </div>


                <frg-form-input [ngClass]="{ 'inactive': formGroup.get('reccurType').value !== 'to-date' }"
                  id="reccurTypeDate" type="date" [formGroup]="formGroup" [control]="formGroup.get('reccurTypeDate')">
                </frg-form-input>
              </div>
            </div>

            <div class="button-container" [ngClass]="{ 'inactive': formGroup.get('repeatType').value !== 'reccur' }">
              <frg-button (activated)="generateEvents()">Générer</frg-button>
            </div>
          </div>
        </div>

        <div class="options-container">
          <frg-form-input label="Conserver informations patients" id="optionKeepPatient" type="checkbox"
            [formGroup]="formGroup" [control]="formGroup.get('optionKeepPatient')" [isCheckLabelAlign]="true">
          </frg-form-input>
          <frg-form-input label="Conserver description du RDV" id="optionKeepDescription" type="checkbox"
            [formGroup]="formGroup" [control]="formGroup.get('optionKeepDescription')" [isCheckLabelAlign]="true">
          </frg-form-input>
        </div>

      </div>

      <div class="events-list">
        <frg-table [keysBody]="events" [keysColumn]="eventsColumnTable" (onClick1)="removeEvent($event)" tableButton1="assets/icons/trash.svg"></frg-table>
      </div>
    </div>
    <div class="buttons-wrapper">
      <frg-button (activated)="cancelCreation()" [backgroundColor]="'var(--darkest-primary)'">Annuler</frg-button>
      <frg-button (activated)="validateCreation()" [disabled]="!events || events.objects.length < 0">Valider
      </frg-button>
    </div>
  </div>
</div>